
import { Component } from '@angular/core';

@Component({
  selector: 'app-capacity-legend',
  standalone: true,
  imports: [],
  templateUrl: './capacity-legend.component.html',
  styleUrls: ['./capacity-legend.component.scss']
})
export class CapacityLegendComponent {}


